import React, { useEffect, useState } from "react";
import { BookingStatusPill } from "@/components/BookingStatus";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { fmtTime } from "@/lib/time";
import type { Booking } from "@/types";

export const TodayList = ({ onPick, refreshKey }: { onPick: (b: Booking) => void; refreshKey: number }) => {
  const { t, lang } = usePrefs();
  const [list, setList] = useState<Booking[] | null>(null);
  useEffect(() => {
    api.get("/venue/bookings/today").then((r) => setList(r.data)).catch(() => setList([]));
  }, [refreshKey]);
  return (
    <section data-testid="today-list" className="space-y-3">
      <h2 className="font-display text-lg font-black">{t("b7.todayList")} {list ? <span className="text-muted-foreground text-sm">· {list.length}</span> : null}</h2>
      {list?.length === 0 && <p data-testid="today-empty" className="text-sm text-muted-foreground">{t("b7.todayEmpty")}</p>}
      <div className="rounded-3xl border bg-card divide-y">
        {list?.map((b) => (
          <button key={b.booking_id} onClick={() => onPick(b)} data-testid={`today-${b.booking_id}`} className="w-full text-start p-3 flex items-center gap-3 hover:bg-accent/60 transition-[background-color]">
            <span className="text-xs font-mono w-12 shrink-0" dir="ltr">{b.start_at ? fmtTime(b.start_at, lang) : ""}</span>
            <span className="flex-1 min-w-0">
              <span className="block font-bold text-sm truncate">{b.customer_name}</span>
              <span className="block text-xs text-muted-foreground truncate">{lang === "ar" ? b.event_title_ar : b.event_title_en}</span>
            </span>
            <span className="text-sm font-black" data-testid={`today-count-${b.booking_id}`}>{b.attended_count || 0}/{b.guests}</span>
            <BookingStatusPill b={b} />
          </button>
        ))}
      </div>
    </section>
  );
};
